import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Logo from "../images/Logo.svg";
import { useLocation, Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import "../styles/InvoiceDetail.css";
import { useAuth } from "../auth/auth";
import html2pdf from "html2pdf.js";
import generatePdfIcon from "../images/generatePdfIcon.svg";
import generateCsvIcon from "../images/generateCsvIcon.svg";
const apiUrl = process.env.REACT_APP_API_URL;

const CompanyInvoiceDetail = () => {
  const location = useLocation();
  const invoiceId = location.state;
  // console.log('location.state ',location.state)
  // console.log('invoiceId ',invoiceId)
  const [invoice, setInvoice] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uniqueDates, setUniqueDates] = useState([]);


  useAuth();

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);

    if (isNaN(numericValue) || numericValue % 1 !== 0) {
      // Check if it's a decimal
      const formattedValue = numericValue.toFixed(2); // Ensure 2 digits after the decimal point
      return formattedValue;
    } else {
      // If it's an integer, add .00 to make it a decimal with 2 digits after the decimal point
      return additions + ".00";
    }
  }

  function calculateEmployeeAmount(employee) {
    const hoursInMinutes = employee.hoursWorked * 60;
    const totalMinutesWorked = hoursInMinutes + employee.minutesWorked;
    const amount = (totalMinutesWorked / 60) * employee.hourlyRate;
    return amount.toFixed(2);
  }

  const handleDownloadOption = (option) => {
    setShowOptions(false);

    if (option === "pdf") {
      handleGeneratePDF(); // Call your PDF generation function
    } else if (option === "csv") {
      generateCSV(invoice); // Call your CSV generation function
    }
  };

  function generateCSV(invoice) {
    const csvContent = [];
  
    // Add headers to the CSV
    csvContent.push(
      "Employee Email,Pay Rate($),Hours,Amount,Invoice Id,Client-Name,Billing-Address,Total-Amount,Issue-Date,Pay-Period,From"
    );
  
    // Add data rows to the CSV
    invoice.selectedDatesEmployees.forEach((entry) => {
      const date = entry.date;
      entry.employees.forEach((employee) => {
        const rowData = [
          employee.email,
          formatInvoiceAdditions(employee.hourlyRate),
          `${employee.hoursWorked}:${employee.minutesWorked.toString().padStart(2, "0")}hr`,
          calculateEmployeeAmount(employee),
          invoice.id,
          invoice.clientName,
          invoice.billingAddress,
          invoice.totalAmount,
          `"${invoice.formattedTimestamp}"`, //issue date,
          `"${invoice.payPeriod}"`,
          "Surplus staff driver",
        ];
        csvContent.push(rowData.join(","));
      });
    });
  
    // Join rows with newline character
    const csvString = csvContent.join("\n");
  
    // Create a Blob containing the CSV data
    const blob = new Blob([csvString], { type: "text/csv" });
  
    // Create a link to download the CSV file
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "invoice-detail.csv";
  
    // Trigger a click on the link to initiate the download
    link.click();
  }
  

  const containerRef = useRef();

  const handleGeneratePDF = () => {
    const container = containerRef.current;

    // Exclude the admin-header section from the content
    const contentToPrint = container.cloneNode(true);
    const adminHeader = contentToPrint.querySelector(".admin-header");
    const generateButton = contentToPrint.querySelector(".generate-pdf-btn");
    if (adminHeader) {
      adminHeader.remove();
    }

    if (generateButton) {
      generateButton.remove();
    }
    contentToPrint.style.backgroundColor = "#EDF6F0";
    html2pdf(contentToPrint, {
      margin: 10,
      filename: "payslip-detail.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { 
        scale: 2,
        windowWidth: 1200
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      output: function (pdf) {
        // Manually initiate the download using the blob
        const blob = pdf.output("blob");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "payslip-detail.pdf";
        link.click();
      },
    });
  };

  useEffect(() => {
    const fetchInvoiceDetail = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post(`${apiUrl}/getCompanyInvoiceDetail`, {
          id: invoiceId,
        });
        //console.log(response.data.data);
        setInvoice(response.data.data);
        const uniqueDatesWithEmployees = response.data.data.selectedDatesEmployees
        .filter(entry => entry.employees.length > 0)
        .map(entry => entry.date);
        setUniqueDates([...new Set(uniqueDatesWithEmployees)]);
        
      } catch (error) {
        console.error("Error fetching invoice detail:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInvoiceDetail();
  }, [invoiceId]);

  // if (!invoice) {
  //   return <Loader />;
  // }

  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <div className="invoice-detail-container" ref={containerRef}>
        <div className="admin-header admin-header-generate-company">
          <div className="left-section invoice-detail-left-section">
            <h1 className="admin-header-title hide-invoice-header-title">
              <Link
                to="/companyInvoiceList"
                className="admin-card-title-link custom-link"
              >
                <span className="fade-text">Invoice List</span>
              </Link>
              {" > "}
              <span className="admin-card-title-span top-heading-invoice-Detail">
                Invoice Detail
              </span>
            </h1>
          </div>
          <div className="right-section">
            <div className="download-right-buttons">
              <button className="generate-pdf-btn" onClick={handleGeneratePDF}>
                <img
                  src={generatePdfIcon}
                  alt="Download"
                  className="downloadIcon"
                />
                Generate PDF
              </button>

              <button
                className="generate-pdf-btn generate-csv-btn"
                onClick={() => generateCSV(invoice)}
              >
                <img
                  src={generateCsvIcon}
                  alt="Download"
                  className="downloadIcon"
                />
                Generate CSV
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="spinner-container">
            <TailSpin
              type="TailSpin"
              color="rgba(135, 106, 237, 1)"
              height={70}
              width={70}
              timeout={5000}
            />
          </div>
        )}
        {invoice && isLoading == false && (
          <div className="invoice-centre-div">
            <div className="invoice-header">
              <div className="invoice-header-left">
                <p className="invoice-heading-decoration">Payslip</p>
              </div>
              <div className="invoice-header-image-right">
                <img src={Logo} alt="Logo" />
              </div>
            </div>

            <div className="invoice-info">
              <p className="margin-zero">{`#${invoice.id}`}</p>
              <p className="margin-zero">
                <span className="issue-date-label">Issue Date - </span>
                {invoice.formattedTimestamp}
              </p>
            </div>

            <div className="green-separator"></div>

            <div className="invoice-middle-header">
              <p className="invoice-bold-text">From</p>
              <p className="invoice-bold-text">To</p>
            </div>
            <div className="invoice-middle-header">
              <p className="invoice-detail-p-text">{`Surplus staff driver`}</p>
              <p className="invoice-detail-p-text">{`${invoice.clientName}`}</p>
            </div>
            <div className="invoice-middle-header">
              <p className="invoice-detail-p-text">{`Surplus@gmail.com`}</p>
              <p className="invoice-detail-p-text">{`${invoice.billingAddress}`}</p>
            </div>
            <div className="invoice-middle-header">
              <p className="invoice-detail-p-text">{`+216587226`}</p>
              <p className="invoice-detail-p-text">{`Total Amount - $${formatInvoiceAdditions(
                invoice.totalAmount
              )}`}</p>
            </div>
            {/* <div className="invoice-middle-header">
              <p className="pay-period">{`Pay Period`}</p>
              <p className="invoice-detail-p-text">{`Pay Rate - $${formatInvoiceAdditions(
                invoice.payRate
              )}`}</p>
            </div> */}
            <div className="invoice-middle-header">
              <p className="invoice-detail-p-text">{`${invoice.payPeriod}`}</p>
            </div>

            <div className="table-container">
            {uniqueDates.map((date, index) => (
              <div key={index}>
                
                <p className="user-detail">{date}</p>
                <table className="invoice-table even-invoice-table invoice-detail-table-main">
                  <thead>
                    <tr>
                      <th>Employee Email</th>
                      <th>Pay Rate($)</th>
                      <th>Hours</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.selectedDatesEmployees
                      .filter(entry => entry.date === date)
                      .map((entry, subIndex) => (
                        <React.Fragment key={subIndex}>
                          {entry.employees.map((employee, subSubIndex) => (
                            <tr key={`${subIndex}-${subSubIndex}`}>
                              <td>{employee.email}</td>
                              <td>${formatInvoiceAdditions(employee.hourlyRate)}</td>
                              <td>
                                {employee.hoursWorked}:
                                {employee.minutesWorked.toString().padStart(2, "0")}hr
                              </td>
                              <td>${calculateEmployeeAmount(employee)}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            ))}
              {/* <div className="table-right">
                <table className="amount-table invoice-table even-invoice-table row-white invoice-detail-table-main">
                  <thead>
                    <tr>
                      <th>Amount</th>
                      <th>YTD Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>${formatInvoiceAdditions(invoice.Amount)}</td>
                      <td>${formatInvoiceAdditions(invoice.YTDFinal || invoice.YTDAmount)}</td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyInvoiceDetail;
